<template>
  <div class="about">
    <AddPosition></AddPosition>
  </div>
</template>

<script>
import AddPosition from '@/components/airbox/AddPosition.vue'

export default {
  name: 'Pilotposition',
  components: {
    AddPosition,
  },
  data: () => ({
    tab: null
  }),
}
</script>